import { redirect } from 'shared/helpers/redirect';
// For safety while we are developing the homepage
// we intercept any call to NH LSRP here and force a page refresh.
// This should be removed once it's live.
export const handleLsrpMapViewRouting = (url: string) => {
    const regexLsrpMapView = new RegExp(
        '/(for-sale|to-rent|new-homes)/map/(property|flats|houses|bungalows|retirement).+$'
    );

    const urlMatches = url.match(regexLsrpMapView);

    if (urlMatches && urlMatches.length > 0) {
        redirect(url);
    }
};
